var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SortableTable',{attrs:{"headers":_vm.headers,"rows":_vm.rows,"key-field":"condition","default-sort-by":"condition","table-actions":false,"row-actions":false,"search":false},scopedSlots:_vm._u([{key:"cell:condition",fn:function(ref){
var row = ref.row;
return [_c('span',{class:{'text-error': row.error}},[_vm._v(_vm._s(row.condition))])]}},{key:"cell:status",fn:function(ref){
var row = ref.row;
return [_c('span',{class:{'text-error': row.error}},[_vm._v(_vm._s(row.status))])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }